document.addEventListener("DOMContentLoaded", () => {

    const overlay = document.querySelector('.menu-overlay');
    const menuButton = document.querySelector('.hamburger');
    const submenuButtons = document.querySelectorAll('.menu-item');
    const closeSubmenuButton = document.querySelector('.submenu-container__back')

    function toggleMenu() {
        if (overlay.classList.contains('active')) {
            closeMenu();
        } else {
            overlay.classList.add('active');
            document.body.style.overflow = 'hidden';
            menuButton.classList.add('active');
        }
    }

    function closeMenu() {
        overlay.classList.remove('active');
        document.body.style.overflow = '';

        document.querySelectorAll('.submenu-container').forEach(submenu => {
            submenu.classList.remove('active');
        });
        menuButton.classList.remove('active');
    }

    function toggleSubmenu(submenuId, clickedButton) {
        const submenu = document.getElementById(submenuId);
        if (!submenu) return;

        const isOpening = !submenu.classList.contains('active');

        document.querySelectorAll('.submenu-container').forEach(sub => {
            sub.classList.remove('active');
        });
        document.querySelectorAll('.menu-item[data-submenu]').forEach(btn => {
            btn.classList.remove('active');
        });

        if (isOpening) {
            submenu.classList.add('active');
            clickedButton.classList.add('active');
        }
    }

    submenuButtons.forEach(button => {
        button.addEventListener('click', (e) => {
            e.preventDefault();
            const submenuId = button.dataset.submenu;
            toggleSubmenu(submenuId, button);
        });
    });

    if (overlay) {
        overlay.addEventListener('click', (e) => {
            if (e.target.classList.contains('menu-overlay')) {
                closeMenu();
            }
        });
    }

    if (menuButton) {
        menuButton.addEventListener('click', toggleMenu);
    }

    if (closeSubmenuButton) {
        closeSubmenuButton.addEventListener('click', () => {
            const parentSubmenu = closeSubmenuButton.closest('.submenu-container');
            if (parentSubmenu) {
                parentSubmenu.classList.remove('active');
            }
        });
    }

});